import React from "react";
import Header from "./component/Header";
import Footer from "./component/Footer";
import Shop from "./component/Shop";
import {ToastContainer} from "react-toastify";

function App () {
    return(
        <>
            <ToastContainer />
            <Header />
            <Shop />
            <Footer />
        </>
    )
}
export default App;